import { render, staticRenderFns } from "./StartNoticeDialog.vue?vue&type=template&id=57d957b7&scoped=true"
import script from "./StartNoticeDialog.vue?vue&type=script&lang=js"
export * from "./StartNoticeDialog.vue?vue&type=script&lang=js"
import style0 from "./StartNoticeDialog.vue?vue&type=style&index=0&id=57d957b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d957b7",
  null
  
)

export default component.exports